import {
    cibFacebook,
    cibTwitter,
    cibLinkedin,
    cibFlickr,
    cibTumblr,
    cibXing,
    cibGithub,
    cibStackoverflow,
    cibYoutube,
    cibDribbble,
    cibInstagram,
    cibPinterest,
    cibVk,
    cibYahoo,
    cibBehance,
    cibReddit,
    cibVimeo,
    cibCcMastercard,
    cibCcVisa,
    cibStripe,
    cilCommentBubble,
    cibPaypal,
    cilZoom,
    cilInfo,
    cilLevelUp,
    cilLevelDown,
    cibGooglePay,

    cibCcAmex, cilPlus, cilMinus, cilFolder, cilClone, cilShare
} from '@coreui/icons'
import {
  cifUs,
  cifBr,
  cifIn,
  cifFr,
  cifEs,
  cifPl
} from '@coreui/icons'
import {
  cilArrowRight,
  cilBan,
  cilBasket,
  cilBell,
  cilCalculator,
  cilCalendar,
  cilCloudDownload,
  cilChartPie,
  cilCheck,
  cilChevronBottom,
  cilChevronTop,
  cilCheckCircle,
  cilCommentSquare,
  cilCursor,
  cilDrop,
  cilDollar,
  cilEnvelopeClosed,
  cilEnvelopeOpen,
  cilEuro,
  cilGlobeAlt,
  cilGrid,
  cilFile,
  cilJustifyCenter,
  cilLaptop,
  cilLayers,
  cilLightbulb,
  cilList,
  cilLocationPin,
  cilLockLocked,
  cilMagnifyingGlass,
  cilMoon,
  cilOptions,
  cilPencil,
  cilPeople,
  cilPuzzle,
  cilSettings,
  cilShieldAlt,
  cilSpeech,
  cilSpeedometer,
  cilStar,
  cilTask,
  cilUser,
  cilUserFemale,
  cilUserFollow,
  cilReload,
    cilLowVision,
    cilCart,
    cilTrash,
    cilAddressBook,
    cilMonitor,
    cilTranslate,
  cilXCircle

} from '@coreui/icons'
import { logo,eye ,page} from './logo'
import {
  navDashboard,
  navMedia,
  navBlog,
  navUsers,
  navOrders,
  navProducts,
  navReports,
  navDisplay,
  navPages,
  navForms,
  navComments,
  navTools,
  navSettings,
  navEye,
  iconSun,
  iconMoon,
  iconBell,
  iconMenu,
  iconClose,
  iconList,
  iconComment,
  iconEdit,
  iconClone,
  iconTrash,
  iconEyeOff,
  iconDollar,
  iconCheck,
  iconStar,
  iconStarFill,
  iconPlus,
  iconDownload,
  iconUpload,
  iconChevronLeft,
  iconChevronRight,
  iconSearch, iconUser, iconLogout, iconChevronDown, iconSidebar, iconExternal, iconRefresh,
} from './navIcons'

export const iconsSet = Object.assign(
  {},
  {
    logo, eye, page,
    navDashboard, navMedia, navBlog, navUsers, navOrders, navProducts,
    navReports, navDisplay, navPages, navForms, navComments, navTools, navSettings, navEye,
    iconSun, iconMoon, iconBell, iconMenu, iconClose, iconList, iconComment,
    iconEdit, iconClone, iconTrash, iconEyeOff, iconDollar, iconCheck,
    iconStar, iconStarFill, iconPlus, iconDownload, iconUpload,
    iconChevronLeft, iconChevronRight, iconSearch, iconUser, iconLogout, iconChevronDown, iconSidebar, iconExternal, iconRefresh,
  },
  {
    cilArrowRight,
    cilBan,
    cilBasket,
    cilBell,
    cilCalculator,
    cilCalendar,
    cilCloudDownload,
    cilChartPie,
    cilCheck,
    cilChevronBottom,
    cilChevronTop,
    cilCheckCircle,
    cilCommentSquare,
    cilCursor,
    cilDrop,
    cilDollar,
    cilEnvelopeClosed,
    cilEnvelopeOpen,
    cilEuro,
    cilGlobeAlt,
    cilGrid,
    cilFile,
    cilJustifyCenter,
    cilLaptop,
    cilLayers,
    cilLightbulb,
    cilList,
    cilLocationPin,
    cilLockLocked,
    cilMagnifyingGlass,
    cilMoon,
    cilOptions,
    cilPencil,
    cilPeople,
    cilPuzzle,
    cilSettings,
    cilShieldAlt,
    cilSpeech,
      cilPlus,
      cilMinus,
    cilSpeedometer,
    cilStar,
    cilTask,
    cilUser,
      cilAddressBook,
      cilMonitor,
      cilUserFemale,
      cilCart,
    cilUserFollow,
    cilXCircle
  },
  {
    cifUs,
    cifBr,
    cifIn,
    cifFr,
    cifEs,
    cifPl
  },
  {
    cibFacebook,
    cibTwitter,
    cibLinkedin,
    cibFlickr,
    cibTumblr,
    cibXing,
    cibGithub,
    cibStackoverflow,
    cibYoutube,
    cibDribbble,
    cibInstagram,
    cibPinterest,
    cibVk,
    cibYahoo,
    cibBehance,
    cibReddit,
    cibVimeo,
    cibCcMastercard, 
    cibCcVisa, 
    cibStripe, 
    cibPaypal, 
    cilShare,
    cibGooglePay,
    cilReload,
      cilPlus,
      cilCommentBubble,
      cilTranslate,
      cilFolder,
      cilClone,
      cilTrash,
      cilZoom,
      cilInfo,
      cilLevelUp,
      cilLevelDown,
      cilLowVision,
    cibCcAmex
  }
)
